import moment from "moment";
import { checkIfOrderContainsShortWeek } from "../components/modules/StartDate/useStartDate";
/**
 * Find dayName for dayId
 * @param dayId number
 * @returns dayName
 */
export const GetDayName = (dayId) => {
    switch (dayId) {
        case 0:
            return "Sunday";
        case 1:
            return "Monday";
        case 2:
            return "Tuesday";
        case 3:
            return "Wednesday";
        case 4:
            return "Thursday";
        case 5:
            return "Friday";
        case 6:
            return "Saturday";
        default:
            return "";
    }
};
/**
 * Formats a date string as MM/DD/YYYY
 * @param date string
 * @returns Date formatted as: MM/DD/YYY
 */
export const FormatDate = (date) => {
    return moment(date).format("l");
};
/**
 * Groups array of objects by a specified key.
 * @param key The key to group by.
 * @param arrayOfObjs Array of objects to group.
 * @returns Grouped object where the keys are values of the specified key and values are arrays of grouped objects.
 */
export const GroupBy = (key, arrayOfObjs) => {
    return arrayOfObjs.reduce((groupedObjs, element) => {
        const groupKey = String(element[key]); // Ensure the key is treated as a string
        if (groupedObjs[groupKey]) {
            groupedObjs[groupKey].push(element);
        }
        else {
            groupedObjs[groupKey] = [element];
        }
        return groupedObjs;
    }, {});
};
//TODO: Being used by multiple js files.
//Once My Meals is refactores this can be moved to a type
export const SubscriptionStatus = {
    None: 0,
    Active: 10,
    Paused: 20,
    Complete: 30,
    Cancelled: 40,
};
/**
 * Separate string array into comma separated string with "and" before the last item
 * @param array string[]
 * @returns Comma separated string
 */
export const FormatArrayWithCommas = (array) => array.length > 2
    ? array
        .slice(0, array.length - 1)
        .concat(`and ${array.slice(-1)}`)
        .join(", ")
    : array.join(" and ");
/**
 * Get first available ship day of week for a given cart state.
 * Priority for first available ship day: earliest meal ship day > start date > first delivery schedule day
 * @param Cart cart
 * @param DeliverySchedule[] deliverySchedule
 * @returns day of week number, -1 if no day found
 */
export const GetFirstAvailableDOW = (cart, deliverySchedule) => {
    if (cart === null || cart === void 0 ? void 0 : cart.meals.length) {
        const currDeliveryDays = cart.meals.map((m) => moment(m.DeliveryDate));
        return moment.min(currDeliveryDays).day();
    }
    else if (cart === null || cart === void 0 ? void 0 : cart.startDate) {
        return moment(cart.startDate).day();
    }
    else if (deliverySchedule === null || deliverySchedule === void 0 ? void 0 : deliverySchedule.length) {
        return deliverySchedule[0].shipDayOfWeek;
    }
    else {
        return -1;
    }
};
/**
 * Find dayFilterId from day string
 * @param filter string
 * @returns dayFilterId
 */
export const GetFilterDayId = (filter, cart, deliverySchedule) => {
    switch (filter.toLowerCase()) {
        case "firstavailable":
            return GetFirstAvailableDOW(cart, deliverySchedule);
        case "sunday":
            return 0;
        case "monday":
            return 1;
        case "tuesday":
            return 2;
        case "wednesday":
            return 3;
        case "thursday":
            return 4;
        case "friday":
            return 5;
        case "saturday":
            return 6;
        default:
            return -1;
    }
};
/**
 * Get subscription meals for current order
 * @param cart Cart
 * @param model Model
 * @returns subscriptionMeals
 */
export const getSubscriptionMeals = (cart, model, forDisplay = true) => {
    let subscriptionMeals = [];
    let dayQuantity = cart.dayQuantity;
    if (!dayQuantity) {
        dayQuantity = cart.daysOfWeek.length;
    }
    const orderIsShortWeek = checkIfOrderContainsShortWeek(cart.startDate, cart.daysOfWeek, dayQuantity);
    let daysForSubscription = cart.daysOfWeek;
    if (orderIsShortWeek) {
        daysForSubscription = cart.daysOfWeek
            .filter((dayOfWeek) => model.DeliveryDays.some((day) => moment(day.MealDate).day() === dayOfWeek))
            .slice(0, dayQuantity);
    }
    else {
        // Reorder daysOfWeek to start from startDate's day, then filter by available delivery days
        const startDay = moment(cart.startDate).day();
        const startIndex = cart.daysOfWeek.indexOf(startDay);
        const reorderedDays = cart.daysOfWeek.slice(startIndex).concat(cart.daysOfWeek.slice(0, startIndex));
        daysForSubscription = reorderedDays
            .filter((dayOfWeek) => model.DeliveryDays.some((day) => moment(day.MealDate).day() === dayOfWeek))
            .slice(0, dayQuantity);
    }
    subscriptionMeals =
        cart.template &&
            cart.template
                .filter((mealDayQuantity) => model.DeliveryDays.some((day) => moment(day.MealDate).day() === mealDayQuantity.DayOfWeek) &&
                daysForSubscription.some((day) => day === mealDayQuantity.DayOfWeek))
                .map((mealDayQuantity) => {
                var _a;
                let dayOfWeek = mealDayQuantity.DayOfWeek;
                if (model.GeneralSettings.OnlyShowDeliveryDays) {
                    dayOfWeek = moment((_a = model.DeliveryDays.find((dd) => moment(dd.MealDateString).day() === mealDayQuantity.DayOfWeek)) === null || _a === void 0 ? void 0 : _a.ShipDateString).day();
                }
                return {
                    MealId: mealDayQuantity.ProgramMealId,
                    Qty: mealDayQuantity.Quantity,
                    DayOfWeek: dayOfWeek,
                    OriginalDayOfWeek: mealDayQuantity.DayOfWeek,
                    MealName: mealDayQuantity.ProgramMealName,
                    Price: mealDayQuantity.Price,
                    MealTypeId: mealDayQuantity.MealTypeId
                };
            });
    // if only showing delivery days, coalesce meal day quantities into delivery days
    // UNLESS editing a sub that has ExplodeOMDD false; in that case, the sub template should still have meal days
    if (!forDisplay && model.GeneralSettings.OnlyShowDeliveryDays && !model.ExplodeOMDD && model.IsEditFlow) {
        subscriptionMeals.forEach((sm) => { var _a; return (sm.DayOfWeek = (_a = sm.OriginalDayOfWeek) !== null && _a !== void 0 ? _a : sm.DayOfWeek); });
    }
    else if (model.GeneralSettings.OnlyShowDeliveryDays) {
        const mealIds = [...new Set(subscriptionMeals.map((sm) => sm.MealId))];
        const daysOfWeek = [...new Set(subscriptionMeals.map((sm) => sm.DayOfWeek))];
        mealIds.forEach((mealId) => {
            daysOfWeek.forEach((dayOfWeek) => {
                var _a, _b, _c;
                const duplicates = subscriptionMeals.filter((sm) => sm.MealId === mealId && sm.DayOfWeek === dayOfWeek);
                if (duplicates.length > 1) {
                    const totalMealQuantity = duplicates.reduce((acc, sm) => acc + sm.Qty, 0);
                    subscriptionMeals = subscriptionMeals.filter((sm) => sm.MealId !== mealId || sm.DayOfWeek !== dayOfWeek);
                    // when ExplodeOMDD is false, we still want to only display delivery days in order flow cart
                    // but subscription template should be based on actual meal days
                    if (forDisplay || model.ExplodeOMDD) {
                        subscriptionMeals.push({
                            MealId: mealId,
                            Qty: totalMealQuantity,
                            DayOfWeek: dayOfWeek,
                            MealName: duplicates[0].MealName,
                            Price: duplicates[0].Price,
                            MealTypeId: duplicates[0].MealTypeId
                        });
                    }
                    else {
                        const cartMeal = cart.meals.find((meal) => meal.ProgramMealId == mealId && moment(meal.DeliveryDate).day() == dayOfWeek);
                        const quantity = Math.ceil(totalMealQuantity / ((_b = (_a = cartMeal === null || cartMeal === void 0 ? void 0 : cartMeal.CoalescedMealDates) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 1));
                        (_c = cartMeal === null || cartMeal === void 0 ? void 0 : cartMeal.CoalescedMealDates) === null || _c === void 0 ? void 0 : _c.forEach((mealDay) => {
                            subscriptionMeals.push({
                                MealId: mealId,
                                Qty: quantity,
                                DayOfWeek: moment(mealDay).day(),
                                MealName: duplicates[0].MealName,
                                Price: duplicates[0].Price,
                            });
                        });
                    }
                }
            });
        });
    }
    subscriptionMeals = subscriptionMeals.sort((a, b) => {
        return a.DayOfWeek - b.DayOfWeek;
    });
    return subscriptionMeals;
};
export var NavPortalRoots;
(function (NavPortalRoots) {
    NavPortalRoots["Pinned"] = "pinned-nav-root";
    NavPortalRoots["Unpinned"] = "unpinned-nav-root";
    NavPortalRoots["EditSubscription"] = "edit-sub-nav-root";
})(NavPortalRoots || (NavPortalRoots = {}));
export const getPortalRoot = (isEditFlow, isPinned) => {
    if (isEditFlow) {
        return document.getElementById(NavPortalRoots.EditSubscription);
    }
    else if (isPinned) {
        return document.getElementById(NavPortalRoots.Pinned);
    }
    else {
        return document.getElementById(NavPortalRoots.Unpinned);
    }
};
/**
 * Generates an ordered array of days starting from a specified start date
 * and optionally limited by the number of days to include (`dayQuantity`).
 *
 * @param {number[]} daysOfWeek - An array of days represented as numbers (0-6 for Sunday-Saturday).
 * @param {Cart["startDate"]} startDate - The start date from which to reorder the days.
 * @param {number} [dayQuantity] - The number of days to include in the output. If not provided, all days are included.
 * @returns {number[]} An array of days reordered to start from the day of `startDate`
 *                     and limited to `dayQuantity` if specified.
 */
export const getTemplateDays = (daysOfWeek, startDate, dayQuantity) => {
    const startDayIndex = daysOfWeek.indexOf(moment(startDate).day());
    // Rearrange the daysOfWeek to start from the startDayIndex and continue to the end,
    // then append the days before startDayIndex to the end, creating a template that starts
    // from the start date and cycles through the days.
    let templateDays = daysOfWeek.slice(startDayIndex).concat(daysOfWeek.slice(0, startDayIndex));
    // Limit the templateDays to only include the number of days specified by dayQuantity.
    templateDays = templateDays.slice(0, dayQuantity);
    return templateDays;
};
